const workerCommands = {
  SEARCH: 'SEARCH',
  CLOSE: 'CLOSE',
  SET_PROPERTY_LIST: 'SET_PROPERTY_LIST',
};

export { workerCommands };
